import React from 'react';
import styles from './UserSearchResultCard.module.css';
import { buildStorageUrl } from '../config/firebaseStorage';

function UserSearchResultCard({ user, onClick }) {
  const handleCardClick = () => {
    if (onClick) {
      onClick(user.username);
    }
  };

  const pfpUrl = user.pfp && user.pfp.trim() !== ''
    ? user.pfp
    : buildStorageUrl('pfp/placeholderP.png'); // Default placeholder from Firebase

  return (
    <div className={styles.userCard} onClick={handleCardClick} style={{ cursor: 'pointer' }}>
      <img src={pfpUrl} alt={`${user.nickname}'s Profile`} className={styles.userPfp} />
      <div className={styles.userInfo}>
        <h3 className={styles.nickname}>{user.nickname}</h3>
        <p className={styles.username}>@{user.username}</p>
      </div>
    </div>
  );
}

export default UserSearchResultCard;
